export default __webpack_public_path__ + "static/media/product-5.9ce203b3.jpg";